export function useContentAreaPadding(): number {
  return 30;
}
